import { createPortal } from 'react-dom'
import Barcode from '../../components/Barcode'
import { labelCode } from './inventoryShared'

// Printable shelf and bin labels: the code in large type, a barcode of the
// label code (the area's barcode, else its path, with the location in front
// when there are several), and the path and location underneath. Hidden on screen; printed on its own like invoices
// (body.ci-printing). `size` is 'small' (3 across) or 'large' (2 across).
export function Label({ area, size = 'small', multiLocation = false }) {
  return (
    <div className={`lbl lbl-${size}`}>
      <div className="lbl-top">
        <span className="lbl-code">{area.code}</span>
        <span className="lbl-level">{area.level}{area.name ? ` · ${area.name}` : ''}</span>
      </div>
      <Barcode className="lbl-barcode" value={labelCode(area, multiLocation)} />
      <div className="lbl-bottom">
        <span className="lbl-path">{area.path}</span>
        {area.location_name && <span className="lbl-loc">{area.location_name}</span>}
      </div>
    </div>
  )
}

export default function LabelSheet({ areas, size, multiLocation = false }) {
  return createPortal(
    <div className="ci-print-wrap" aria-hidden="true">
      <style>{'@media print { @page { margin: 10mm; } }'}</style>
      <div className={`lbl-sheet lbl-sheet-${size}`}>
        {areas.map((a) => <Label key={a.area_id} area={a} size={size} multiLocation={multiLocation} />)}
      </div>
    </div>,
    document.body,
  )
}
